export const userSurvey = [
    {
        questionId: "Stock Market Sector",
        label: "Which stock market sectors are you primarily interested in?How useful is the prosthesis for the activity?",
        options: [
            {
                label: "Technology",
                value: 0,
            },
            {
                label: "Finance",
                value: 1,
            },
            {
                label: "Energy",
                value: 2,
            },
            {
                label: "Healthcare",
                value: 3,
            },
            {
                label: "Consumer Goods",
                value: 4,
            },
            {
                label: "Others",
                value: 5,
            },
        ],
    }, {
        questionId: "Investment Strategy",
        label: "What is your investment strategy?",
        options: [
            {
                label: "Long-term buy and hold",
                value: 0,
            },
            {
                label: "Active trading",
                value: 1,
            },
            {
                label: "Value investing",
                value: 2,
            },
            {
                label: "Growth investing",
                value: 3,
            },
            {
                label: "Others",
                value: 4,
            },
        ],
    }, {
        questionId: "Real-time updates",
        label: "Would you prefer to receive real-time alerts for significant stock market events?",
        options: [
            {
                label: "Yes",
                value: 0,
            },
            {
                label: "No",
                value: 1,
            },
        ],
    }, {
        questionId: "Updates Frequency",
        label: "How often would you like to receive stock updates and predictions?",
        options: [
            {
                label: "Daily",
                value: 0,
            },
            {
                label: "Weekly",
                value: 1,
            },
            {
                label: "Bi-weekly",
                value: 2,
            },
            {
                label: "Monthly",
                value: 3,
            },
        ],
    }, {
        questionId: "Level",
        label: "What level of detail would you prefer for stock analysis and predictions?",
        options: [
            {
                label: "Beginner (simple explanations and basic insights)",
                value: 0,
            },
            {
                label: "Intermediate (moderate level of technical analysis)",
                value: 1,
            },
            {
                label: "Advanced (in-depth technical and fundamental analysis)",
                value: 2,
            },

        ],
    }
]